export const contentClasses = 'tw:flex tw:flex-col tw:gap-base tw:p-base';

export const scanQrContainerClasses =
  'tw:flex tw:flex-col tw:items-center tw:gap-base';

export const scanQrViewfinderClasses =
  'tw:relative tw:w-full tw:aspect-square tw:rounded-8 tw:overflow-hidden tw:bg-black';

export const scanQrErrorClasses =
  'tw:flex tw:items-center tw:justify-center tw:py-huge tw:text-center';

export const vehicleSectionClasses =
  'tw:border tw:border-solid tw:border-gray-light tw:rounded-8 tw:overflow-hidden';

export const vehicleSectionHeaderClasses =
  'tw:px-base tw:pt-base tw:pb-small tw:text-14 tw:font-medium tw:text-gray-darker';

export const vehicleItemClasses =
  'tw:flex tw:items-center tw:justify-between tw:gap-base tw:px-base tw:py-small tw:cursor-pointer tw:hover:bg-gray-lighter tw:transition-colors';

export const vehicleItemLeftClasses = 'tw:flex tw:items-center tw:gap-small tw:min-w-0';

export const vehicleNameClasses = 'tw:text-14 tw:font-medium tw:text-font tw:truncate';

export const vehiclePlateClasses = 'tw:text-14 tw:font-regular tw:text-gray-darker tw:shrink-0';

export const vehicleIconClasses = 'tw:text-gray-dark tw:shrink-0';

export const searchingContainerClasses =
  'tw:flex tw:flex-col tw:items-center tw:gap-base tw:py-huge';

export const spinnerClasses =
  'tw:w-12 tw:h-12 tw:border-4 tw:border-gray-light tw:border-t-primary tw:rounded-full tw:animate-spin';

export const resultContainerClasses =
  'tw:flex tw:flex-col tw:items-center tw:gap-base tw:py-large';

export const successIconClasses =
  'tw:w-14 tw:h-14 tw:rounded-full tw:bg-[#e8f5e9] tw:flex tw:items-center tw:justify-center';

export const resultCardClasses =
  'tw:w-full tw:border tw:border-solid tw:border-gray-light tw:rounded-8 tw:p-base';

export const resultCardBodyClasses =
  'tw:flex tw:flex-col tw:gap-micro md:tw:flex-row md:tw:justify-between';

export const resultCardInfoClasses = 'tw:flex tw:flex-col tw:gap-micro tw:min-w-0';

export const resultCardGarageRowClasses = 'tw:flex tw:items-center tw:gap-small';

export const resultCardAmountClasses = 'tw:flex tw:flex-col tw:items-end tw:shrink-0';

export const noResultClasses =
  'tw:flex tw:flex-col tw:items-center tw:gap-base tw:py-huge tw:text-center';
